import React, { Component } from 'react';
import { message, Popconfirm, Button, Icon, DatePicker, Select, InputNumber, Input } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import { RelateVisit, OtherExplain } from './Widget';
import TableC from '../../basicElement/TableC';
import ReportModal from '../ReportModal';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import SideNav from '../SideNav';
import moment from 'moment';
import '../css/index.less';
import RemindWriteDate from './RemindWriteDate.js';

let current;
let siteList = [];
const dateFormat = 'YYYY-MM-DD';
const Option = Select.Option;

class WriteManhour extends Component {
    constructor(props) {
        super(props);
        const { match } = props;
        const { params } = match || {};
        const { date, manHourId } = params || {};
        this.state = {
            loading: false,
            isAddBtn: true,
            manHourId,
            maxDate: null,
            newRowData: {},
            dataSource: [],
            roleOptions: [],
            searchParams: {
                date: date ? date.split('.').join('-') : '',
            },
        };
    }

    componentDidMount() {
        this.queryEffectiveDate();
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
            const { searchParams } = this.state;
            searchParams.date = date;
            this.setState({
                searchParams,
                maxDate: date,
            }, () => {
                this.loadData();
            });
        });
    }

    loadData = () => {
        this.setState({
            loading: true,
            isAddBtn: true,
        });
        const { searchParams } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.manhour.list,
            data: { ...searchParams },
            dateType: 'json',
            doneResult: data => {
                if (JSON.stringify(data) == '{}') {
                    this.setState({
                        loading: false,
                        dataSource: [],
                        newRowData: {},
                    });
                    return;
                }
                // 将数据构造好后，存入state,让table取
                const dataList = data.data.manHours;
                const date = data.data.date;
                let totalTime = 0;
                const dataSource = dataList.map((item, index) => {
                    const { duration, workTypeId, investigationName, investigationCode, investigationSiteCode, enterpriseWorkCategoryName, enterpriseWorkCategoryCode, enterpriseWorkTypeString } = item;
                    totalTime += duration * 1;
                    return {
                        ...item,
                        key: index,
                        investigationName: investigationName || enterpriseWorkCategoryName,
                        investigationCode: investigationName ? (investigationCode ? `(${investigationCode})` : '()') : (enterpriseWorkCategoryCode ? `(${enterpriseWorkCategoryCode})` : '()'),
                        // investigationSiteCode: investigationSiteCode ? `(${investigationSiteCode})` : null,
                        enterpriseWorkTypeId: workTypeId,
                        enterpriseWorkTypeName: enterpriseWorkTypeString,
                        duration: duration || 0,
                        date,
                        workCategoryId: item.enterpriseWorkCategoryId,
                    };
                });
                dataSource.push({
                    key: dataList.length,
                    investigationName: '总计',
                    totalTime: totalTime.toFixed(2),
                });
                this.setState({
                    dataSource,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    handleDateChange = (date, dateString) => {
        const { searchParams } = this.state;
        searchParams.date = dateString;
        this.setState({ searchParams }, () => {
            this.loadData();
        });
    }

    switchDay = type => {
        const { searchParams } = this.state;
        const { date } = searchParams;
        if (type === 'prev') {
            searchParams.date = moment(date).subtract(1, 'days').format(dateFormat);
        } else {
            searchParams.date = moment(date).add(1, 'days').format(dateFormat);
        }
        this.setState({
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    edit = index => {
        const { dataSource } = this.state;
        dataSource[index].isEdit = true;
        this.setState({ dataSource });
    }

    save = (record, index) => {
        const {
            key,
            roleId,
            manHourId,
            investigationId,
            investigationSiteId,
            investigationSiteName,
            enterpriseWorkTypeId,
            duration,
            date,
            workCategoryId,
            enterpriseWorkNameId,
            manHourVisits,
            remarks,
            needRemindWriteDate, 
        } = record;
        if (key === 'new') {
            const params = {};
            if (investigationSiteName !== '---' && enterpriseWorkNameId == '9') {
                if (manHourVisits.length) {
                    manHourVisits.forEach((item, index) => {
                        params[`manHourVisits[${index}].userId`] = item.userId;
                        params[`manHourVisits[${index}].patientCode`] = item.patientCode;
                        params[`manHourVisits[${index}].manHourVisitDetails[0].visitTypeId`] = item.visitTypeId || item.visitTypeIds[0];
                    });
                } else {
                    message.warning('请关联患者(访视)!');
                    return;
                }
            }
            if (!enterpriseWorkTypeId) {
                message.warning('有未选项！');
                return;
            } else if (!duration) {
                message.warning('请填写工时！');
                return;
            }
            if (needRemindWriteDate == '1') {
                this.remindWriteDateRef.show(record);
                return
            }
            this.setState({ loading: true });
            const options = {
                method: 'POST',
                url: API_URL.manhour.editaddmanhour,
                data: {
                    manHourId,
                    manHourDate: date.slice(0, 10),
                    investigationId,
                    investigationSiteId,
                    enterpriseWorkCategoryId: workCategoryId,
                    roleId,
                    enterpriseWorkNameId,
                    workTypeId: enterpriseWorkTypeId,
                    duration,
                    remarks,
                    ...params,
                },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.data.success);
                    this.setState({
                        loading: false,
                    }, () => {
                        this.loadData();
                    });
                },
                errorResult: () => {
                    this.setState({ loading: false });
                },
            };
            $.sendRequest(options);
        } else {
            this.setState({ loading: true });
            const options = {
                method: 'POST',
                url: API_URL.manhour.editmanhour,
                data: {
                    manHourId,
                    duration,
                    remarks,
                },
                dataType: 'json',
                doneResult: data => {
                    message.success(data.data.success);
                    this.setState({
                        loading: false,
                    }, () => {
                        this.loadData();
                    });
                },
                errorResult: () => {
                    this.setState({ loading: false });
                },
            };
            $.sendRequest(options);
        }
    }

    delete = record => {
        const { key, manHourId } = record;
        if (key === 'new') {
            const { dataSource } = this.state;
            dataSource.splice(0, 1);
            this.setState({
                isAddBtn: true,
                dataSource,
            });
        } else {
            const options = {
                method: 'POST',
                url: API_URL.manhour.delmanhour,
                data: { manHourId },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.data.success);
                    this.loadData();
                },
            };
            $.sendRequest(options);
        }
    }

    getColumns = () => [{
        title: '项目简称(项目编号)',
        dataIndex: 'investigationName',
        key: 'investigationName',
        fixed: 'left',
        width: 180,
        render: (text, record) => {
            const { key, manHourId: rManHourId } = record;
            const { manHourId, searchParams } = this.state;
            const { date } = searchParams;
            if (key == 'new') {
                return (
                    <SearchRetrieve
                        keyword="keyword"
                        style={{ width: 160 }}
                        value={text}
                        params={{ limit: 20, date }}
                        url={API_URL.manhour.queryCategory}
                        config={{ id: 'enterpriseWorkCategoryId', name: 'enterpriseWorkCategoryName', type: 'projectName' }}
                        onChange={value => this.handleChange(value, 'investigationName')}
                    />
                );
            }
            return (
                    (rManHourId === manHourId && manHourId) ?
                        <span style={{ color: 'red' }}>{text}</span>
                    :
                        text
            );
        },
    }, {
        title: '中心名称(中心编号)',
        dataIndex: 'investigationSiteName',
        key: 'investigationSiteName',
        width: 140,
        render: (text, record) => {
            const { key, investigationId, investigationSiteName, investigationSiteCode, courtyardArea, departmentName, investigationName } = record;
            if (key === 'new') {
                return (
                    !!investigationId &&
                    <SearchRetrieve
                        keyword="keyword"
                        style={{ width: 120 }}
                        value={text}
                        params={{ investigationId, roleCode: 'CRC' }}
                        url={API_URL.site.queryUserSiteListByUserId}
                        config={{ id: 'investigationSiteId', name: 'investigationSiteName', code: 'investigationSiteCode', show: 'codeSitecourtyardArea' }}
                        onChange={value => this.handleChange(value, 'investigationSiteName')}
                    />
                );
            }
            return investigationSiteName == '---' || investigationName == '总计' ? investigationSiteName : `${investigationSiteCode?`${investigationSiteCode}-`: ''}${investigationSiteName || ''}${courtyardArea?`（${courtyardArea}）`: '-'}${departmentName || ''}`  //在中心名称为'---'的行或总计行中，中心名称不套用此格式
        },
    }, {
        title: '角色',
        dataIndex: 'roleCode',
        key: 'roleCode',
        width: 100,
        render: (text, record) => {
            const { key, roleId, workCategoryId, investigationSiteId, investigationSiteName } = record;
            if (key === 'new') {
                const { roleOptions } = this.state;
                const roleOption = roleOptions.map(d => <Option key={d.roleId}>{d.roleCode}</Option>);
                return (
                    !!(workCategoryId || investigationSiteId || investigationSiteName === '---') &&
                    <Select
                        style={{ width: 80 }}
                        onChange={this.handleSelect}
                        value={roleId ? String(roleId) : undefined}
                        allowClear
                    >
                        {roleOption}
                    </Select>
                );
            }
            return text;
        },
    }, {
        title: '工作类型',
        dataIndex: 'enterpriseWorkNameValue',
        key: 'enterpriseWorkNameValue',
        width: 140,
        render: (text, record, index) => {
            const { key, roleId, workCategoryId, investigationId, investigationSiteName } = record;
            if (key === 'new') {
                const params = {};
                const { roleOptions } = this.state;
                const roleCode = (roleOptions.find(i => i.roleId == roleId) || {}).roleCode;
                if (roleCode === 'CRC' || roleCode === 'CRCC') {
                    if (investigationSiteName && investigationSiteName !== '---') {
                        params.isRelateInvestigation = 1;
                    } else if (investigationSiteName === '---') {
                        params.isRelateInvestigation = 0;
                    }
                }
                return (
                    !!roleId &&
                    <SearchRetrieve
                        keyword="keyword"
                        style={{ width: 120 }}
                        value={text}
                        params={{ roleId, investigationId, enterpriseWorkCategoryId: workCategoryId, ...params }}
                        url={API_URL.manhour.queryEnterpriseNameById}
                        config={{ id: 'enterpriseWorkNameId', name: 'enterpriseWorkNameValue' }}
                        onChange={value => this.handleChange(value, 'enterpriseWorkNameValue', index, record)}
                    />
                );
            }
            return text;
        },
    }, {
        title: '患者访视',
        dataIndex: 'patientVisit',
        key: 'patientVisit',
        width: 160,
        render: (text, record, index) => {
            const { key, manHourVisits, investigationSiteName, enterpriseWorkNameValue } = record;
            const type = key === 'new' ? 'add' : 'edit';
            const len = manHourVisits ? manHourVisits.length : 0;
            return (
                <div style={{ paddingRight: 20 }}>
                    {
                        !!len &&
                        manHourVisits.map((item, index) => {
                            const { userId, patientCode, visitTypeName, visitTypeNames, manHourVisitId } = item;
                            return (
                                <span key={manHourVisitId || userId}>
                                    {patientCode}({visitTypeName || visitTypeNames.join(',')}){index < (len - 1) && ',' }
                                    <br />
                                </span>
                            );
                        })
                    }
                    {
                        enterpriseWorkNameValue === '患者访视' && investigationSiteName !== '---' &&
                        <Icon
                            style={{ position: 'absolute', right: 10, top: '38%', color: '#23cb23', cursor: 'pointer' }}
                            onClick={() => this.showRelateVisit({ ...record, manHourVisits }, type, index)}
                            type="edit"
                        />
                    }
                </div>
            );
        },
    }, {
        title: '工作内容(编号)',
        dataIndex: 'enterpriseWorkTypeName',
        key: 'enterpriseWorkTypeName',
        width: 200,
        render: (text, record, index) => {
            const { key, roleId, investigationId, investigationSiteName, workCategoryId, enterpriseWorkNameId } = record;
            if (key === 'new') {
                const params = {};
                const { roleOptions } = this.state;
                const roleCode = (roleOptions.find(i => i.roleId == roleId) || {}).roleCode;
                if (roleCode === 'CRC' || roleCode === 'CRCC') {
                    if (investigationSiteName && investigationSiteName !== '---') {
                        params.isRelateInvestigation = 1;
                    } else if (investigationSiteName === '---') {
                        params.isRelateInvestigation = 0;
                    }
                }
                return (
                    !!enterpriseWorkNameId &&
                    <SearchRetrieve
                        keyword="keyword"
                        style={{ width: 180 }}
                        value={text}
                        params={{ roleId, enterpriseWorkNameId, workCategoryId, investigationId, ...params }}
                        url={workCategoryId ? API_URL.manhour.queryWorkTypeNot : API_URL.manhour.queryWorkType}
                        config={{ id: 'enterpriseWorkTypeId', name: 'enterpriseWorkTypeName', code: 'enterpriseWorkTypeCode', show: 'workTypes', type: 'workTypes' }}
                        onChange={value => this.handleChange(value, 'enterpriseWorkTypeName', index)}
                    />
                );
            }
            return text;
        },
    }, {
        title: '工时',
        dataIndex: 'duration',
        key: 'duration',
        width: 100,
        render: (text, record, index) => {
            const { key, isEdit, totalTime, isCounting, investigationName } = record;
            if (investigationName !== '总计') {
                return (
                    <div>
                        {
                            (isEdit || key === 'new') ?
                                <div>
                                    <InputNumber
                                        min={0}
                                        max={24}
                                        step={0.01}
                                        onChange={value => this.durationChanged(value, index)}
                                        style={{ width: 65, verticalAlign: 'middle' }}
                                    />
                                    &nbsp;h
                                </div>
                            :
                                <span>{record.duration}h</span>
                        }
                        {
                            (isCounting === '2' && !isEdit && key !== 'new') &&
                            <span>
                                <span className="ant-divider" />
                                <Icon type="exception" style={{ color: '#FF9900' }} />
                            </span>
                        }
                    </div>
                );
            }
            return <span>{totalTime}h</span>;
        },
    }, {
        title: '备注',
        dataIndex: 'remarks',
        key: 'remarks',
        width: 100,
        render: (text, record, index) => {
            const { key, isEdit, isCounting } = record;
            return <div>
                {
                    (isEdit || key === 'new') ?
                        <div>
                            <Input
                                placeholder="请输入"
                                value={text}
                                onChange={e => this.tableChanged(e.target.value, 'remarks', index)}
                            />
                        </div>
                    :
                        <span>{text}</span>
                }
            </div>
        },
    }, {
        title: '操作',
        key: 'action',
        fixed: 'right',
        width: 100,
        render: (text, record, index) => {
            const {
                key,
                isEdit,
                roleCode,
                manHourId,
                investigationName,
                remarks,
                enterpriseWorkNameValue,
                investigationSiteName,
                enterpriseWorkTypeName,
            } = record;
            if (investigationName !== '总计') {
                return (
                    <div>
                        {
                            (key === 'new' || isEdit) ?
                                <a onClick={() => this.save(record, index)}>保存</a>
                            :
                                <a onClick={() => this.edit(index)}>修改</a>
                        }
                        <span className="ant-divider" />
                        <Popconfirm title={'确定要删除吗?'} onConfirm={() => this.delete(record)} okText="确定" cancelText="取消">
                            <a>删除</a>
                        </Popconfirm>
                        {
                            roleCode == 'CRC' && enterpriseWorkNameValue == '其他' && enterpriseWorkTypeName == '其他项目相关(65)' && investigationSiteName != '---' &&
                            <span>
                                <span className="ant-divider" />
                                <a onClick={() => this.showOtherExplain({ manHourId, remarks }, index)}>其他说明</a>
                            </span>
                        }
                    </div>
                );
            }
        },
    }]

    // ①、只有一个中心：
    //    按该中心查角色，然后回填数据
    // ②、有两中心，其中一个是---中心：
    //    先按---中心查角色，根据查到的角色个数判断。
    //        一个角色：如果是PA/PM，直接回填数据；如果是CRC/CRCC，则按另一个中心执行①
    //        多个角色：如果只有CRC/CRCC，则按另一个中心执行①；否则什么都不做

    queryInvestigationSite = investigationId => {
        const options = {
            method: 'POST',
            url: API_URL.site.queryUserSiteListByUserId,
            data: {
                roleCode: 'CRC',
                investigationId,
            },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                siteList = data;
                if (data.length === 1) {
                    const [{ investigationSiteId, investigationSiteName, investigationSiteCode, courtyardArea, departmentLocalName, needRemindWriteDate, userRoleInvestigationSiteCrcId }] = data;
                    this.queryRole({ investigationId, investigationSiteId, investigationSiteName, investigationSiteCode, courtyardArea, departmentLocalName, needRemindWriteDate, userRoleInvestigationSiteCrcId }, 1);
                } else if (data.length === 2) {
                    const result = data.filter(i => i.investigationSiteName === '---');
                    const [{ investigationSiteId, investigationSiteName, investigationSiteCode, courtyardArea, departmentLocalName, needRemindWriteDate, userRoleInvestigationSiteCrcId }] = result;
                    this.queryRole({ investigationId, investigationSiteId, investigationSiteName, investigationSiteCode, courtyardArea, departmentLocalName, needRemindWriteDate, userRoleInvestigationSiteCrcId }, 1);
                } else {
                    this.handleChange({}, 'investigationSiteName');
                }
            },
        };
        $.sendRequest(options);
    }

    // @params:set
    // 默认不设，1：项目选择；2：中心选择
    queryRole = (params, set) => {
        const options = {
            method: 'POST',
            url: API_URL.manhour.queryRole,
            data: { ...params },
            dataType: 'json',
            doneResult: res => {
                const { data: { roles } } = res;
                this.setState({ roleOptions: roles }, () => {
                    const { investigationId, investigationSiteId, investigationSiteName, investigationSiteCode, courtyardArea, departmentLocalName, needRemindWriteDate, userRoleInvestigationSiteCrcId } = params;
                    console.log(params);
                    if (set === 1) {
                        if (investigationSiteName === '---') {
                            const [{ roleId, roleCode }] = roles;
                            if (roles.length === 1) {
                                if (roleCode === 'PA' || roleCode === 'PM') {
                                    this.handleChange({ value: investigationSiteId, text: investigationSiteName == '---' ? investigationSiteName : `${investigationSiteCode ? `${investigationSiteCode}-` : ''}${investigationSiteName}${courtyardArea ? `（${courtyardArea}）`:'-'}${departmentLocalName ? `${departmentLocalName}`:''}`, needRemindWriteDate, userRoleInvestigationSiteCrcId}, 'investigationSiteName', () => this.handleSelect(roleId));
                                } else if (roleCode === 'CRC' || roleCode === 'CRCC') {
                                    const result = siteList.filter(i => i.investigationSiteName !== '---');
                                    const [{ investigationSiteId, investigationSiteName, investigationSiteCode, courtyardArea, departmentLocalName, needRemindWriteDate, userRoleInvestigationSiteCrcId }] = result;
                                    this.queryRole({ investigationId, investigationSiteId, investigationSiteName, investigationSiteCode, courtyardArea, departmentLocalName, needRemindWriteDate, userRoleInvestigationSiteCrcId }, 1);
                                }
                            } else if (roles.every(i => i.roleCode === 'CRC' || i.roleCode === 'CRCC')) {
                                const result = siteList.filter(i => i.investigationSiteName !== '---');
                                const [{ investigationSiteId, investigationSiteName, investigationSiteCode, courtyardArea, departmentLocalName, needRemindWriteDate, userRoleInvestigationSiteCrcId }] = result;
                                this.queryRole({ investigationId, investigationSiteId, investigationSiteName, investigationSiteCode, courtyardArea, departmentLocalName, needRemindWriteDate, userRoleInvestigationSiteCrcId }, 1);
                            } else if (roles.every(i => i.roleCode === 'PA' || i.roleCode === 'PM')) {
                                this.handleChange({ value: investigationSiteId, text: investigationSiteName == '---' ? investigationSiteName : `${investigationSiteCode ? `${investigationSiteCode}-` : ''}${investigationSiteName}${courtyardArea ? `（${courtyardArea}）`:'-'}${departmentLocalName ? `${departmentLocalName}`:''}`, needRemindWriteDate, userRoleInvestigationSiteCrcId }, 'investigationSiteName');
                            }
                        } else if (roles.length === 1) {
                            const [{ roleId, roleCode }] = roles;
                            if (roleCode === 'CRC' || roleCode === 'CRCC') {
                                this.handleChange({ value: investigationSiteId, text: investigationSiteName == '---' ? investigationSiteName : `${investigationSiteCode ? `${investigationSiteCode}-` : ''}${investigationSiteName}${courtyardArea ? `（${courtyardArea}）`:'-'}${departmentLocalName ? `${departmentLocalName}`:''}`, needRemindWriteDate, userRoleInvestigationSiteCrcId }, 'investigationSiteName', () => this.handleSelect(roleId));
                            }
                        } else if (roles.length === 2) {
                            if (roles.every(i => i.roleCode === 'CRC' || i.roleCode === 'CRCC')) {
                                this.handleChange({ value: investigationSiteId, text: investigationSiteName == '---' ? investigationSiteName : `${investigationSiteCode ? `${investigationSiteCode}-` : ''}${investigationSiteName}${courtyardArea ? `（${courtyardArea}）`:'-'}${departmentLocalName ? `${departmentLocalName}`:''}`, needRemindWriteDate, userRoleInvestigationSiteCrcId }, 'investigationSiteName');
                            }
                        }
                    } else if (set === 2) {
                        const [{ roleId, roleCode }] = roles;
                        if (roles.length === 1) {
                            if (roleCode === 'CRC' || roleCode === 'CRCC') {
                                this.handleSelect(roleId);
                            }
                        }
                    }
                });
            },
        };
        $.sendRequest(options);
    }

    handleChange = (option, key, index, record) => {
        const { newRowData, dataSource } = this.state;
        if (key === 'investigationName') {
            const { invesId, enterpriseWorkCategoryName, enterpriseWorkCategoryId } = option;
            newRowData.investigationName = enterpriseWorkCategoryName;
            if (invesId) {
                newRowData.investigationId = invesId;
                newRowData.workCategoryId = '';
            } else if (enterpriseWorkCategoryId) {
                newRowData.investigationId = '';
                newRowData.workCategoryId = enterpriseWorkCategoryId;
            } else {
                newRowData.investigationId = '';
                newRowData.workCategoryId = '';
            }
            dataSource[0] = newRowData;
            this.setState({ newRowData, dataSource }, () => {
                if (invesId || !Object.keys(option).length) {
                    if (invesId) {
                        this.queryInvestigationSite(invesId);
                    } else {
                        this.handleChange({}, 'investigationSiteName');
                    }
                } else {
                    this.queryRole(newRowData);
                    this.handleSelect();
                }
            });
        } else if (key === 'investigationSiteName') {
            const { value, text, needRemindWriteDate, userRoleInvestigationSiteCrcId } = option;
            newRowData.investigationSiteId = value;
            newRowData.investigationSiteName = text;
            newRowData.needRemindWriteDate = needRemindWriteDate;
            newRowData.userRoleInvestigationSiteCrcId = userRoleInvestigationSiteCrcId;
            dataSource[0] = newRowData;
            this.setState({ newRowData, dataSource }, () => {
                if (typeof index === 'function') {
                    index();
                    return;
                }
                if (value || value === 0) {
                    this.queryRole(newRowData, 2);
                } else {
                    this.setState({ roleOptions: [] });
                }
                this.handleSelect();
            });
        } else if (key === 'enterpriseWorkNameValue') {
            const { value, text } = option;
            newRowData.manHourVisits = [];
            newRowData.enterpriseWorkNameId = value;
            newRowData.enterpriseWorkNameValue = text;
            dataSource[0] = newRowData;
            this.setState({ newRowData, dataSource }, () => {
                const { newRowData } = this.state;
                const { investigationId, enterpriseWorkNameValue, investigationSiteId, investigationSiteName } = newRowData;
                if (enterpriseWorkNameValue == '患者访视' && investigationSiteName !== '---') {
                    const { manHourVisits } = record;
                    this.showRelateVisit({ investigationId, investigationSiteId, manHourVisits }, 'add', index);
                }
                this.handleChange({}, 'enterpriseWorkTypeName');
            });
        } else if (key === 'enterpriseWorkTypeName') {
            const { value, text } = option;
            newRowData.enterpriseWorkTypeId = value;
            newRowData.enterpriseWorkTypeName = text;
            dataSource[0] = newRowData;
            this.setState({ newRowData, dataSource }, () => {
                const { roleId, enterpriseWorkNameValue, enterpriseWorkTypeName, investigationSiteName } = newRowData;
                if (roleId == 123 && enterpriseWorkNameValue == '其他' && enterpriseWorkTypeName == '其他项目相关(65)' && investigationSiteName !== '---') {
                    this.showOtherExplain({}, index);
                }
            });
        }
    }

    handleSelect = value => {
        const { newRowData, dataSource } = this.state;
        newRowData.roleId = value;
        dataSource[0] = newRowData;
        this.setState({ newRowData, dataSource }, () => {
            this.handleChange({}, 'enterpriseWorkNameValue');
        });
    }

    durationChanged = (value, index) => {
        const { dataSource } = this.state;
        dataSource[index].duration = value;
        this.setState({ dataSource });
    }
    
    tableChanged = (value, key, index) => {
        const { dataSource } = this.state;
        dataSource[index][key] = value;
        this.setState({ dataSource });
    }

    handleAdd = () => {
        const { searchParams: { date }, newRowData, dataSource } = this.state;
        let params = null;
        if (dataSource.length > 1) {
            const item = dataSource[dataSource.length - 2];
            const { workCategoryId, investigationId, investigationSiteName, investigationSiteCode, courtyardArea, departmentName } = item;
            params = {
                ...item,
                investigationId: workCategoryId ? '' : investigationId,
                enterpriseWorkTypeName: '',
                enterpriseWorkTypeId: '',
                duration: '',
                key: 'new',
                investigationSiteName: investigationSiteName == '---' ? investigationSiteName : `${investigationSiteCode?`${investigationSiteCode}-`: ''}${investigationSiteName || ''}${courtyardArea?`（${courtyardArea}）`: '-'}${departmentName || ''}`,
            };
        } else {
            params = {
                ...newRowData,
                key: 'new',
                date,
            };
        }
        this.setState({
            newRowData: params,
            dataSource: [params, ...dataSource],
            isAddBtn: false,
        }, () => {
            if (dataSource.length > 1) {
                const { newRowData } = this.state;
                const { investigationId, investigationSiteId } = newRowData;
                this.queryRole(newRowData);
                if (investigationId) {
                    this.setSiteParams(investigationId, investigationSiteId);
                }
            }
        });
    }

    setSiteParams = (investigationId, investigationSiteId) => { 
        const options = {
            method: 'POST',
            url: API_URL.site.queryUserSiteListByUserId,
            data: {
                roleCode: 'CRC',
                investigationId,
            },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const { newRowData, dataSource } = this.state;
                const { needRemindWriteDate, userRoleInvestigationSiteCrcId } = data.filter(el => el.investigationSiteId == investigationSiteId)[0];
                newRowData.needRemindWriteDate = needRemindWriteDate;
                newRowData.userRoleInvestigationSiteCrcId = userRoleInvestigationSiteCrcId;
                dataSource[0] = newRowData;
                this.setState({ newRowData, dataSource });
            },
        };
        $.sendRequest(options);
    }

    report = data => {
        this.reportModalRef.show(data);
    }

    showRelateVisit = (params, type, index) => {
        current = index;
        this.relateVisitRef.show(params, type);
    }

    showOtherExplain = (params, index) => {
        current = index;
        this.otherExplainRef.show(params);
    }

    saveVisitData = manHourVisits => {
        const { dataSource } = this.state;
        dataSource[current].manHourVisits = manHourVisits;
        this.setState({ dataSource });
    }

    saveRemarks = remarks => {
        const { dataSource } = this.state;
        dataSource[current].remarks = remarks;
        this.setState({ dataSource });
    }

    render() {
        const { disableSider, hideHourModal } = this.props;
        const { searchParams, maxDate, isAddBtn, loading, dataSource, roleOptions } = this.state;
        const { date } = searchParams;
        return (
            <div className="content">
                { !disableSider && <SideNav selectKey="write" /> }
                <div className="main writeManhour">
                    <div className="T-tit">
                        <div className="txt">
                            <h3>工时记录 </h3>
                            <div style={{ lineHeight: '28px' }}>
                                <a
                                    onClick={() => this.switchDay('prev')}
                                    style={{ position: 'relative', top: 2, marginRight: 4 }}
                                >
                                    <Icon type="left-circle-o" />
                                </a>
                                <DatePicker
                                    onChange={this.handleDateChange}
                                    value={date ? moment(date) : null}
                                    format={dateFormat}
                                    allowClear={false}
                                    disabledDate={current => (current && current.valueOf()) > moment(maxDate).valueOf()}
                                    style={{ verticalAlign: 'bottom' }}
                                />
                                <a
                                    onClick={() => this.switchDay('next')}
                                    style={{ position: 'relative', top: 2, marginLeft: 4 }}
                                    disabled={moment(date).isSameOrAfter(moment(maxDate).format(dateFormat))}
                                >
                                    <Icon type="right-circle-o" />
                                </a>
                            </div>
                        </div>
                        <div className="btn">
                            <Button type="primary" onClick={this.handleAdd} disabled={!isAddBtn}>添加</Button>
                            <span className="ant-divider" />
                            <Button type="primary" onClick={this.report}>导出</Button>
                        </div>
                    </div>
                    <TableC
                        data={dataSource}
                        loading={loading}
                        className="writeManhour"
                        columns={this.getColumns()}
                        scrollY={disableSider && 280}
                    />
                    <ReportModal ref={el => this.reportModalRef = el} />
                    <RelateVisit ref={el => this.relateVisitRef = el} saveVisitData={this.saveVisitData} loadData={this.loadData} />
                    <OtherExplain ref={el => this.otherExplainRef = el} saveRemarks={this.saveRemarks} reLoad={this.loadData} />
                    <RemindWriteDate 
                        ref={el => this.remindWriteDateRef = el} 
                        save={this.save} 
                        roleOptions={roleOptions} 
                        hideHourModal={hideHourModal} 
                    />
                </div>
            </div>
        );
    }
}

export default WriteManhour;



// WEBPACK FOOTER //
// ./src/components/manHour/writeManhour/index.js